var exports = {
  "k": "EmbedAudio.module__container___SWlYb2",
  "G": "EmbedAudio.module__deleteButton___SWlYb2",
};

module.exports = exports;
